import React, {FC, ReactNode} from 'react';
import {TouchableOpacity} from 'react-native';
import {useBalance} from 'wagmi';

import AddressInfo from '@/components/AddressInfo';
import Space from '@/components/Space';
import Text from '@/components/Text';
import spacing from '@/constants/spacing';
import {useThemedStyles} from '@/theme';
import {IAddress} from '@/types/common';
import {formatPrice} from '@/utils/ethereum';

import {styles} from './WalletCard.style';

export interface IWalletCardProps {
  wallet: IAddress;
  onPress: (address: string) => void;
  isSelected?: boolean;
  chainId?: number;
  suffix?: ReactNode;
  disabled?: boolean;
}

const WalletCard: FC<IWalletCardProps> = ({
  wallet,
  onPress,
  isSelected = false,
  chainId,
  suffix,
  disabled = false,
}) => {
  const style = useThemedStyles(styles);
  const {data: balance} = useBalance({
    address: wallet.address,
    chainId,
    enabled: !!chainId,
  });

  return (
    <TouchableOpacity
      disabled={disabled}
      activeOpacity={0.8}
      onPress={() => onPress(wallet.address)}
      style={[style.wallet, isSelected && style.wallet_selected]}>
      <Space flex>
        <AddressInfo
          address={wallet}
          avatarSize={spacing.m * 1.5}
          showConnectionIndicator
        />
      </Space>
      {chainId && balance && (
        <Text size="xs">
          {formatPrice(
            balance.value,
            {
              decimals: balance.decimals,
              symbol: balance.symbol,
            },
            4,
          )}
        </Text>
      )}
      {suffix}
    </TouchableOpacity>
  );
};

export default WalletCard;
